import { mapGetters } from 'vuex'
import {
  commonUtil,
  countryUtil,
  currencyUtil,
  countryCallingCodeUtil
} from '@/util'
import {
  ExpansionPanel,
  InputFormNew,
  PhoneNumberInput,
  PostalCodeArea,
  SelectRegion,
  SelectCountry
} from '@/components/items'

import detail from './detail'

export default {
  components: {
    ExpansionPanel,
    InputFormNew,
    PhoneNumberInput,
    PostalCodeArea,
    SelectRegion,
    SelectCountry
  },
  props: {
    clientInfo: {}
  },
  data: () => {
    return {
      isEdit: { default: false },

      // Design
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 3,
        contentsCols: 12 - 3,
        inputItemHeight: '32px'
      },
      clientDetail: detail.detail,

      clientData: {
        clientInfo: {},

        invoiceInfo: {
          fullName: '',
          organizationName: '',
          phone: {
            countryCode: {},
            phoneNumber: ''
          },
          country: {},
          postalCode: '',
          region: '',
          address1: '',
          address2: ''
        },
        receiverInfo: {
          copyInvoiceInfo: false,
          addReceiverInfo: false,
          receiverName: '',
          organizationName: '',
          fullName: '',
          phone: {
            countryCode: {},
            phoneNumber: ''
          },
          country: {},
          postalCode: '',
          region: '',
          address1: '',
          address2: ''
        },
        saleInfo: {
          currency: { label: '', value: null },
          saleDate: ''
        }
      },

      // 受取人情報
      recipientList: [],
      recipientNameList: []
    }
  },
  created() {
    this.getClientData()
  },
  methods: {
    ...mapGetters('Common', [
      'getCountryListFromState',
      'getCountryCallingCodeJpFromState',
      'getCountryJpFromState',
      'getCurrencyJpFromState'
    ]),

    getClientData() {
      ;[this.clientData.saleInfo].map((ele) => {
        ele.saleDate = commonUtil.getToday()
      })
      ;[this.clientData.saleInfo].map((ele) => {
        ele.currency = this.getCurrencyJpFromState()
      })

      if (!Object.keys(this.clientInfo).length) {
        ;[
          this.clientData.invoiceInfo.phone,
          this.clientData.receiverInfo.phone
        ].map((ele) => {
          ele.countryCode = this.getCountryCallingCodeJpFromState()
        })
        ;[this.clientData.invoiceInfo, this.clientData.receiverInfo].map(
          (ele) => {
            ele.country = this.getCountryJpFromState()
          }
        )
        return
      }

      this.isEdit = 'saleId' in this.clientInfo
      this.setCtomerData()
    },
    setCtomerData() {
      this.setRecipientNameList()

      const clientInfoTmp = { ...this.clientInfo }

      this.clientData = {
        clientInfo: this.isEdit ? clientInfoTmp.customer : clientInfoTmp,
        invoiceInfo: this.setinvoiceInfo(clientInfoTmp),
        receiverInfo: this.setInitReceiverInfo(clientInfoTmp),
        saleInfo: this.setSaleInfo(clientInfoTmp, {
          ...this.clientData.saleInfo
        })
      }
    },

    setRecipientNameList() {
      const recipients = this.isEdit
        ? this.clientInfo.customer.recipients
        : this.clientInfo.recipients

      this.recipientNameList = !recipients.length
        ? []
        : recipients.map((rec) => {
            return this.getRecipientNameObj(rec)
          })
    },

    format(propertyName) {
      const identifier = this.isEdit ? 'recipient' : ''

      return identifier
        ? identifier +
            propertyName.slice(0, 1).toUpperCase() +
            propertyName.slice(1)
        : propertyName
    },
    setinvoiceInfo(list) {
      return {
        fullName: list.billingName,
        organizationName: list.billingOrganizationName,
        phone: {
          countryCode: countryCallingCodeUtil.getPhoneNumberInfoById(
            list.billingPhoneNumberCountryId
          ),
          phoneNumber: list.billingPhoneNumber
        },
        country: countryUtil.getCountryIdInfo(list.billingAddressCountryId),
        postalCode: list.billingPostalCode,
        region: countryUtil.getRegionInfo(
          list.billingAddressCountryId,
          list.billingRegionId
        ),
        address1: list.billingAddress1,
        address2: list.billingAddress2
      }
    },
    setInitReceiverInfo(list) {
      const recipients = this.isEdit
        ? list.customer.recipients
        : list.recipients

      if (!this.isEdit && !recipients.length) {
        return {
          copyInvoiceInfo: false,
          addReceiverInfo: false,
          receiverName: { label: '', value: null },
          organizationName: '',
          fullName: '',
          phone: {
            countryCode: this.getCountryCallingCodeJpFromState(),
            phoneNumber: ''
          },
          country: this.getCountryJpFromState(),
          postalCode: '',
          region: { label: '', value: null },
          address1: '',
          address2: ''
        }
      }

      const listTmp = this.isEdit ? list : list.recipients[0]

      return this.setReceiverInfo(listTmp)
    },
    setReceiverInfo(list) {
      const ret = {
        receiverName: this.getRecipientNameObj(list),
        organizationName: list[this.format('organizationName')],
        fullName: list[this.format('name')],
        phone: {
          countryCode: countryCallingCodeUtil.getPhoneNumberCountryIdInfo(
            list[this.format('phoneNumberCountryId')]
          ),
          phoneNumber: list[this.format('phoneNumber')]
        },
        country: countryUtil.getCountryIdInfo(
          list[this.format('addressCountryId')]
        ),
        postalCode: list[this.format('postalCode')],
        region: countryUtil.getRegionInfo(
          list[this.format('addressCountryId')],
          list[this.format('regionId')]
        ),
        address1: list[this.format('address1')],
        address2: list[this.format('address2')]
      }

      return ret
    },
    resetReceiverInfo() {
      this.clientData.receiverInfo.receiverName = { label: '', value: null }
      this.clientData.receiverInfo.organizationName = ''
      this.clientData.receiverInfo.fullName = ''
      // this.clientData.receiverInfo.phone.countryCode = {
      //   label: '',
      //   value: null
      // }
      this.clientData.receiverInfo.phone.countryCode =
        this.getCountryCallingCodeJpFromState()
      this.clientData.receiverInfo.phone.phoneNumber = ''
      // this.clientData.receiverInfo.country = { label: '', value: null }
      this.clientData.receiverInfo.country = this.getCountryJpFromState()
      this.clientData.receiverInfo.postalCode = ''
      this.clientData.receiverInfo.region = { label: '', value: null }
      this.clientData.receiverInfo.address1 = ''
      this.clientData.receiverInfo.address2 = ''
    },
    setSaleInfo(list, saleInfo) {
      return {
        currency: this.isEdit
          ? currencyUtil.getCurrencyIdInfo(list.currencyId)
          : saleInfo.currency,
        saleDate: this.isEdit ? list.saleDate : saleInfo.saleDate
      }
    },

    onClickPostalCodeInvoiceInfo(...args) {
      const [address] = args
      this.setPostalCode(address, 'invoiceInfo')
    },
    onClickPostalCodeReceiverInfo(...args) {
      const [address] = args
      this.setPostalCode(address, 'receiverInfo')
    },
    setPostalCode(address, infoName) {
      this.clientData[infoName].region = countryUtil.getRegionInfoByName(
        this.clientData[infoName].country.value,
        address.region
      )
      this.clientData[infoName].address1 = address.locality
      this.clientData[infoName].address2 = address.street
    },

    receiverChange(newValue) {
      const storage = this.isEdit
      this.isEdit = false
      this.clientData.receiverInfo = this.setReceiverInfo(
        this.clientInfo.recipients.find(
          (ele) => ele.recipientId === newValue.value
        )
      )
      this.isEdit = storage
    },
    getRecipientNameObj(rec) {
      return { label: rec.name, value: rec.recipientId }
    }
  },

  watch: {
    clientInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.getClientData()
      }
    },
    clientData: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('change', newVal)
      }
    }
  }
}
